/**************************************************
 * Nombre:       Dialogo_Depocitar
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Deposito from "../Formularios/Formulario_Deposito";
import {Outbox} from '@mui/icons-material'
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../Recursos/logo_redondo.svg'
import {useContext, useRef, useState} from "react";
import {usuarioContext} from "../../App";
import {crearDeposito} from "../../CodigoCliente/Depositos/crearDeposito";
import {useNavigate} from "react-router";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {envioNotificacionWass} from "../../CodigoCliente/Notificaciones/envioNotificacionWass";
import {formatoMonedaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";
import {NUMEROWASS} from "../../Constantes";
import {debounce} from "lodash";

const Dialogo_Depocitar = ({cerrar, realizado}) => {
    const cData = useContext(usuarioContext)
    const {sCell} = useResponsive()
    const navigate = useNavigate()
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: {}})
    const {Cargador, Avisos, iniciarCarga, nuevoAviso, terminar} = useCargador({
        logoRedondo: logo,
        funcionUno: cerrar,
        funcionDos: realizado
    })
    const [cargando, setCargando] = useState(false)



    const clickSubir = () =>{
        setCargando(true)
        enviarDatos().then(() =>{
            setCargando(false)
        })
    }

    const enviarDatos = async () => {

        let entidad = await obtenerEntidad()

        if (entidad.valor < 1) {
            terminar({aviso: 'El valor mínimo de depósito es de $1 USD', variante: 'error'})
            return
        }

        if (!entidad.img) {
            terminar({aviso: 'Porfavor enviar el pantallazo o soporte de transacción', variante: 'error'})
            return
        }

        setCargando(true)
        await crearDeposito({
            entidad: entidad,
            iniciarCarga: iniciarCarga,
            nuevoAviso: nuevoAviso,
            terminar: terminar,
            usuario: cData.usuario
        })

        envioNotificacionWass({
            numero: NUMEROWASS,
            mensaje: `Nuevo depósito \n${cData.usuario.correo} \n${formatoMonedaTabla(entidad.valor)} \n${entidad.tipo}`
        })

        setCargando(false)
        navigate('/Historial')

    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
        >

            <Cargador/>

            <Avisos/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Formulario_Deposito props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mb: 2}}>
                <Button
                    loading={cargando}
                    onClick={() => clickSubir()}
                    startIcon={<Outbox/>}>Enviar Depósito</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Depocitar    